import { graphql } from 'react-relay';

export const UserGeoLocationAdd = graphql`
  mutation UserGeoLocationAddMutation($input: UserGeoLocationAddInput!) {
    UserGeoLocationAdd(input: $input) {
      error
    }
  }
`;
